// extracted by mini-css-extract-plugin
export var cancelButton = "_ob-5";
export var content = "_ob-3";
export var createButton = "_ob-6";
export var drawerContainer = "_ob-0";
export var footer = "_ob-2";
export var header = "_ob-1";
export var orderFormColumn = "_ob-4";